import { __assign } from "tslib";
import { renderAndMountComponent } from '@wix/answers-lib';
import * as React from 'react';
import { Toggle } from './toggle';
import { jsdomReactUniDriver } from '@unidriver/jsdom-react';
export var createToggleDriver = function (wrapper) {
    var baseDriver = wrapper.$('.toggle');
    return {
        isOn: function () { return baseDriver.hasClass('on'); },
        isOff: function () { return baseDriver.hasClass('on').then(function (hasClass) { return !hasClass; }); },
        isDisabled: function () { return baseDriver.hasClass('disabled'); },
        toggle: function () {
            return baseDriver.click();
        },
        hasTooltip: function () { return baseDriver.hasClass('has-tooltip'); },
    };
};
export var createToggle = function (props) {
    var elem = jsdomReactUniDriver(renderAndMountComponent(React.createElement(Toggle, __assign({}, props))));
    return createToggleDriver(elem);
};
//# sourceMappingURL=toggle.driver.js.map